import { isReferredId, getRefHostCompId, isRefComponent, getRootRefHostCompId, SHARED_PARTS_PREFIX, } from '../../utils/structureUtils';
import { getFindNicknameConnectionFu, getMissingComponentDefinitions, } from '../../utils/addComponentToOpenWidgetUtils';
export class AddElementsApi {
    constructor(editorSDK, masterStructureFetcher) {
        this.editorSDK = editorSDK;
        this.masterStructureFetcher = masterStructureFetcher;
        this.openAddElementsPanel = async (widgetRef) => {
            const componentRef = isReferredId(widgetRef.id)
                ? {
                    id: getRefHostCompId(widgetRef.id),
                    type: widgetRef.type,
                }
                : widgetRef;
            const isRef = await isRefComponent(this.editorSDK, componentRef);
            const widgetDeletedComponents = await (isRef
                ? this.getClosedWidgetDeletedComponents(componentRef)
                : this.getOpenWidgetDeletedComponents(widgetRef));
            const compToSelect = isRef
                ? await this.getRefHostCompPointer(widgetRef)
                : componentRef;
            await this.editorSDK.editor.openAddElementsPanel('token', {
                components: widgetDeletedComponents.map((component) => ({
                    label: component.role,
                    isEssential: false,
                })),
                widgetRef: componentRef,
                shouldHaveReset: !isRef,
                compToSelect,
            });
        };
    }
    async isNestedInSharedBlock(componentRef) {
        const rootRefHostId = getRootRefHostCompId(componentRef.id);
        if (!rootRefHostId) {
            return false;
        }
        if (rootRefHostId === SHARED_PARTS_PREFIX) {
            return true;
        }
        const refComp = await this.editorSDK.document.components.getById('token', {
            id: rootRefHostId,
        });
        const data = (await this.editorSDK.components.data.get('token', {
            componentRef: refComp,
        }));
        return ((Boolean(data) && data.type === 'InternalRef' && data.pageId == null) ||
            (Boolean(data) && data.pageId === 'masterPage'));
    }
    async getClosedWidgetDeletedComponents(widgetRef) {
        let componentRef = widgetRef;
        // It is a workaround, the right fix should be done in the viewer.
        // Do this under https://jira.wixpress.com/browse/WBL-913
        if (await this.isNestedInSharedBlock(componentRef)) {
            componentRef =
                await this.editorSDK.components.refComponents.getTemplateComponent('token', {
                    componentRef,
                });
        }
        return this.editorSDK.components.refComponents.getCollapsedRefComponents('token', {
            componentRef,
        });
    }
    async getOpenWidgetDeletedComponents(widgetRef) {
        const masterStructure = await this.masterStructureFetcher.fetchMasterStructure(widgetRef);
        const removedStructures = await getMissingComponentDefinitions(this.editorSDK, masterStructure, widgetRef);
        const getConnection = getFindNicknameConnectionFu(masterStructure);
        return removedStructures.map((structure) => getConnection(structure));
    }
    async getRefHostCompPointer(widgetRef) {
        const [firstAncestor] = await this.editorSDK.components.getAncestors('token', {
            componentRef: widgetRef,
        });
        return firstAncestor;
    }
}
//# sourceMappingURL=AddElementsPanelApi.js.map